import { render, staticRenderFns } from "./AppLookupModal.vue?vue&type=template&id=870a0aa6&"
import script from "./AppLookupModal.vue?vue&type=script&lang=js&"
export * from "./AppLookupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports